import type { TGlobalSearchTranslate } from "@frontend-shared/types";
import type { i18n as TI18n } from "i18next";

const NAMESPACE_SEPARATOR = ":";

interface ICreateGlobalSearchTranslateProps {
  translator: TI18n;
  // NOTE: The active language, tried first.
  language: string;
  fallbackLanguage: string;
}

// NOTE: NSAI-6589 — the static index names its titles and synonyms as
// fully-qualified "namespace:path" keys chosen at runtime, which the app's
// literal-typed `t` cannot accept. Reading the resource directly keeps that
// widening in one place without a cast: the active language first, then the
// app's fallback, then the key itself (the same thing i18next shows for a
// missing key).
export const createGlobalSearchTranslate = ({
  translator,
  language,
  fallbackLanguage,
}: ICreateGlobalSearchTranslateProps): TGlobalSearchTranslate => {
  const languages = [
    language,
    translator.resolvedLanguage,
    fallbackLanguage,
  ].filter((candidate): candidate is string => Boolean(candidate));

  return (key: string): string => {
    const separatorIndex = key.indexOf(NAMESPACE_SEPARATOR);
    if (separatorIndex === -1) return key;
    const namespace = key.slice(0, separatorIndex);
    const path = key.slice(separatorIndex + 1);

    for (const candidate of languages) {
      const value: unknown = translator.getResource(candidate, namespace, path);
      if (typeof value === "string") return value;
    }
    return key;
  };
};
